import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/chi-sono", label: "Chi sono", testid: "nav-link-about" },
  { to: "/di-cosa-mi-occupo", label: "Di cosa mi occupo", testid: "nav-link-services" },
  { to: "/media", label: "Media", testid: "nav-link-media" },
  { to: "/contatti", label: "Contatti", testid: "nav-link-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `relative text-sm font-medium tracking-wide transition-colors duration-300 ${
      isActive ? "text-white" : "text-white/60 hover:text-white"
    } after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-[#E8F1EC] after:transition-all after:duration-300 ${
      isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
    }`;

  return (
    <header data-testid="main-header" className="sticky top-0 z-50 bg-[#0D3327] shadow-[0_1px_0_rgba(232,241,236,0.08)]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="header-brand" className="group" onClick={() => setOpen(false)}>
          <span className="block font-serif text-lg font-semibold leading-tight text-white sm:text-xl">
            Professor Carlo Enrico Traverso
          </span>
          <span className="block text-[11px] uppercase tracking-[0.22em] text-[#E8F1EC]/50 transition-colors duration-300 group-hover:text-[#E8F1EC]/80">
            Oftalmologia e Chirurgia Oculare
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Navigazione principale">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/"} data-testid={item.testid} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/richiedi-una-valutazione"
            data-testid="nav-cta-evaluation"
            className="rounded-full bg-[#E8F1EC] px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-[#0D3327] transition-colors duration-300 hover:bg-white"
          >
            Richiedi una valutazione
          </Link>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          onClick={() => setOpen(!open)}
          className="rounded-md p-2 text-white transition-colors duration-300 hover:bg-white/10 lg:hidden"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="border-t border-white/10 bg-[#0D3327] px-4 pb-6 pt-2 lg:hidden"
          aria-label="Navigazione mobile"
        >
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-${item.testid}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-medium transition-colors duration-300 ${
                    isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/richiedi-una-valutazione"
              data-testid="mobile-nav-cta-evaluation"
              onClick={() => setOpen(false)}
              className="mt-3 rounded-full bg-[#E8F1EC] px-6 py-3 text-center text-xs font-semibold uppercase tracking-[0.14em] text-[#0D3327]"
            >
              Richiedi una valutazione
            </Link>
          </div>
        </nav>
      )}
      <span className="hidden">{location.pathname}</span>
    </header>
  );
};
